
import LoadSimple from "../../LoadSimple";
import Modal from 'react-modal';
import ModalDeleteModel from "./ModalDeleteModel";
import { useState, useEffect } from "react";
import { capitalizeFirstLetter } from "../../../utils/utils";
import { lang } from "../../generales/traduction";
import ModalHostList from "./ModalHostLis";
import { permisos_codigo_id } from "../../generales/GroupsId";
const deleteUserModalStyles = {
  content: {
    top: '50%',
    left: '50%',
    background: '#ffffff !important',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    width:'30%',
    height:'20%',
    padding:'20px'
  },
};
const hostListModalStyles = {
  content: {
    top: "50%",
    left: "50%",
    background: "#ffffff !important",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    width: "50%",
    height: "90%",
    padding: "20px",
  },
};
const ModelsList = ({
  pageActual,
  limitList,startLimit,
  dataList,
  devices,
  handleChangEdit,
  setData,
  setRegisterIsValid,
  setLoading,
  setError,
  server,
  dataUsers,
  setDataUsers,
  searchResults,
  setSearchResults,
  searchTerm,
  setSearchTerm,
  cisSelected,
  setCisSelected,
  languaje,
  mode,
  rowSelected,
  poolRows,
  handleShowPopup, userPermissions
}) => {
  const [deleteUserModalOpen, setDeleteUserModalOpen] =useState(false);
  const [userSelected,setUserSelected]=useState({})
  const [hostsListModalOpen, setHostsListModalOpen] =useState(false);
  function openDeleteUserModal() {
    setDeleteUserModalOpen(true);
  }

  function closDeleteUserModal() {
    setSearchTerm("")
    setDeleteUserModalOpen(false);
  }
  function openHostsListModal() {
    setHostsListModalOpen(true);
  }

  function closHostsListModal() {
    
    setHostsListModalOpen(false);
  }
  const handledeleteUserClick = (data) => {
        
    openDeleteUserModal()
    setUserSelected(data)
    // Realiza las acciones deseadas al hacer clic en el marcador
  };
  const handleHostLisClick = (data) => {
        
    openHostsListModal()
    setUserSelected(data)
    // Realiza las acciones deseadas al hacer clic en el marcador
  };
  useEffect(() => {
    buscar_cis();
  }, []);
  const buscar_cis = () => {
    // setLoadingCis(true)
    const fetchDataPost = async () => {
      try {
        const response = await fetch(
          server.url +
            "/api/v1/cassia/host_models/",
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              accept: "application/json",
              Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            },
          }
        );
        if (response.ok) {
          const data1 = await response.json();
          setDataUsers(data1);
          // setCreateCisModalOpen(true)
        } else {
          const data1 = await response.json();
          throw new Error("Error en la solicitud");
        }
      } catch (error) {
        console.error(error);
      }
    };

    fetchDataPost();
  };
  const cisSelectRow = (elemento) => {
    setCisSelected(elemento);
  };

  return (
    <>
      <div className="cont-row-user-list">
        {dataUsers.loading ? (
          <div className="cont-load-user-list">
            <LoadSimple></LoadSimple>
          </div>
        ) : (
          dataList
            .slice(startLimit, parseInt(pageActual) * parseInt(limitList))
            .map((elemento, indice) => (
              <div
                className={"row-table-portafolio"+mode}
                key={indice}
              >
                 <div className="field-body-table-mantenimiento field-small">
                 <div className='cont-checkbox'>
                 <input type='checkbox' checked={poolRows.some((row) => row === elemento.model_id)} className='NotifiCheckBox ' style={{height:'15px'}}  onClick={()=>rowSelected(elemento)} ></input>
                </div>
                </div>
                <div className="field-body-table-mantenimiento field-larger">
                  {elemento.model_id}
                </div>
                <div className="field-body-table-mantenimiento field-larger" style={{width:'25%'}}>
                  {elemento.name_model}
                </div>
                <div className="field-body-table-mantenimiento field-larger" style={{width:'25%'}}>
                  {elemento.name_brand}
                </div>
                <div className="field-body-table-mantenimiento field-larger" style={{width:'25%'}}>
                  {elemento.hosts}
                </div>
               
                
                
                <div className="field-body-table-mantenimiento field-larger">
                <>
                     <div style={{width:'33%'}}>
                  <img
                    src={
                      "/iconos/review.png"
                    } 
                    onClick={()=>{handleHostLisClick(elemento)}}
                    name="Editar" title="Ver" className="btnAction delteException" style={{width:'45%'}}
                  />
                  </div>
                  {/* {
                    
                    (elemento.editable==0)?'':
                    <>
                    {userPermissions.some(
            (objeto) => objeto.permission_id === permisos_codigo_id["editar modelo"]
          )?
                      <div style={{width:'33%'}}>
                  <img
                    src={
                      "/iconos/editar.png"
                    } 
                    onClick={()=>handleChangEdit(elemento)}
                    name="Editar" title="Editar" className="btnAction delteException" style={{width:'45%'}}
                  />
                  </div>:''}
                  
                  {userPermissions.some(
            (objeto) => objeto.permission_id === permisos_codigo_id["eliminar modelo"]
          )?
                    <div style={{width:'33%'}}>
                  <img
                    src={
                      "/iconos/delete.png"
                    } 
                    onClick={()=>handledeleteUserClick(elemento)}
                    name="Eliminar"  title='Eliminar' className="btnAction delteException" style={{width:'45%'}}
                  />
                  </div>:''}
                    </>
                  } */}
                  </>
                </div>
              </div>
            ))
        )}
        { dataList.length == 0 ? (
          <div className="no-results">{capitalizeFirstLetter(lang[languaje]['sinResultados'])}.</div>
        ) : (
          ""
        )}
      </div>
      <Modal
        isOpen={deleteUserModalOpen}
        // isOpen={true}
        // onAfterOpen={afterOpenExeption}
        onRequestClose={closDeleteUserModal}
        style={deleteUserModalStyles}
        contentLabel="Example Modal2"
        // shouldCloseOnOverlayClick={false}
        >
          <ModalDeleteModel handleShowPopup={handleShowPopup} languaje={languaje} mode={mode} buscar_cis={buscar_cis} server={server} setData={setData} setLoading={setLoading} setError={setError} user={userSelected} closDeleteUserModal={closDeleteUserModal}></ModalDeleteModel>
    </Modal>
    <Modal
        isOpen={hostsListModalOpen}
        // isOpen={true}
        // onAfterOpen={afterOpenExeption}
        onRequestClose={closHostsListModal}
        style={hostListModalStyles}
        contentLabel="Example Modal2"
        // shouldCloseOnOverlayClick={false}
        >
          <ModalHostList handleShowPopup={handleShowPopup} languaje={languaje} mode={mode} buscar_cis={buscar_cis} server={server} setData={setData} setLoading={setLoading} setError={setError} brand={userSelected} closHostsListModal={closHostsListModal}></ModalHostList>
    </Modal>
    </>
  );
};

export default ModelsList;
